'use client'

import React from 'react'
import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'

interface MotionHighlightProps {
  children: React.ReactNode
  className?: string
  highlightClassName?: string
  isActive?: boolean
  duration?: number
  delay?: number
}

export default function MotionHighlight({
  children,
  className,
  highlightClassName = 'bg-primary/10',
  isActive = false,
  duration = 0.3,
  delay = 0,
}: MotionHighlightProps) {
  return (
    <motion.div
      className={cn('relative', className)}
      initial={false}
      animate={{
        scale: isActive ? 1.02 : 1,
      }}
      transition={{
        duration,
        delay,
        ease: 'easeInOut',
      }}
      whileHover={{
        scale: 1.02,
        transition: { duration: 0.2 },
      }}
      whileTap={{
        scale: 0.98,
        transition: { duration: 0.1 },
      }}
    >
      <motion.div
        className={cn(
          'absolute inset-0 rounded-lg',
          highlightClassName
        )}
        initial={{ opacity: 0 }}
        animate={{
          opacity: isActive ? 1 : 0,
        }}
        transition={{
          duration,
          delay,
        }}
      />
      <div className="relative z-10">{children}</div>
    </motion.div>
  )
}